import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  DialogActions,
  CardContent,
  TextField,
  Divider,
  IconButton,
  Tooltip,
  CircularProgress,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AdminList from "./AdminList";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import {
  createAdminRequest,
  editAdminRequest,
  fetchPermissionsRequest,
} from "../../../redux/AdminList/adminSlice";
import { toast } from "react-toastify";
import { RxCross2 } from "react-icons/rx";
import { useLocation } from "react-router-dom";
import { getActiveCountriesRequest } from "../../../redux/CountryList/CountrySlice";
import auth from "../../../configs/auth";
import { canShowPermission } from "../Permissions/permissionObject";

const CreateAdmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { admins = [] } = useSelector((state) => state.admin || {});
  const { activeCountries = [] } = useSelector((state) => state.country || {});
  const configData = useSelector((state) => state?.appConfig?.configData || {});
  const allState = useSelector((state) => state || {});
  const [refresh, setRefresh] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState("");
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const location = useLocation();
  const [permissions, setPermissions] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [user, setUser] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [dialCode, setDialCode] = useState("");
  const [mobileLength, setMobileLength] = useState(10);
  const [allowAdminMobileAccess, setAllowAdminMobileAccess] = useState(false);
  const isAllowAdminMobileAccessFeatureEnabled =
    configData?.featureToggle?.allow_admin_mobile_access === true ||
    configData?.featureToggle?.allow_admin_mobile_access === "true" || configData?.data?.featureToggle?.Allow_admin_mobile_access === true || configData?.data?.featureToggle?.Allow_admin_mobile_access === "true";
  const jeweller = sessionStorage.getItem(auth.selectedJeweller);
 
  const [selectedJewellerId, setSelectedJewellerId] = useState(() => {
    return sessionStorage.getItem(auth.selectedJeweller) || ""; 
  });
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const jewellerID = storedUser?.jeweller;

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (error) {
        console.error("Error parsing storedUser:", error);
      }
    }
  }, []);
  const { permissions: reduxPermissions, permissionsLoading } = useSelector(
    (state) => state.admin
  );
  const createdRoles = reduxPermissions?.createdRoles || [];
  const finalJewellerId =
    selectedJewellerId && selectedJewellerId.trim() !== ""
      ? selectedJewellerId
      : jewellerID;
  const filteredRoles = createdRoles.filter(
    (r) => r.jeweller === finalJewellerId
  );
   useEffect(() => {
    dispatch(getActiveCountriesRequest({ jeweller :finalJewellerId}));
  }, [dispatch]);

  useEffect(() => {
    if (user && user._id) {
      const finalJewellerId =
        selectedJewellerId && selectedJewellerId.trim() !== ""
          ? selectedJewellerId
          : jewellerID;

      dispatch(
        fetchPermissionsRequest({
          userId: user._id,
          jewellerId: finalJewellerId,
        })
      );
    }
  }, [user?._id, selectedJewellerId, jewellerID, dispatch]);

  const resetForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setRole("");
    setSelectedRoleId("");
    setSelectedCountry(null);
    setDialCode("");
    setMobileLength(10);
    setAllowAdminMobileAccess(false);
  };

  const handleOpenDialog = () => {
    resetForm(); //Data will get reset
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedUser(null);
  };

  useEffect(() => {
    if (location.state?.openCreateAdmin) {
      setOpenDialog(true);
    }
  }, [location.state]);

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");

    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error("Error parsing stored permissions", error);
      }
    }
  }, []);
  const canCreateAdmin = canShowPermission(permissions, "admins", "create");
  const Permission = canShowPermission(permissions, "Permissions", "view");

  const populateEditForm = (user) => {
    const [fname = "", lname = ""] = user.name?.split(" ") || [];
    setFirstName(fname);
    setLastName(lname);
    setEmail(user.email || "");
    setPhone(user.phone || "");
    setAllowAdminMobileAccess(user.allowAdminMobileAccess === true);
    const roleName = user.userRole?.role || "";
    setRole(roleName);

    const matchedRole = createdRoles.find((r) => r.role === roleName);
    if (matchedRole) {
      setSelectedRoleId(matchedRole._id);
    } else {
      setSelectedRoleId(user.userRole?._id || null);
    }
    if (user.countryCode) {
      const matchedCountry = activeCountries.find(
        (c) => c._id === user.countryCode._id || c._id === user.countryCode
      );
      if (matchedCountry) {
        setSelectedCountry(matchedCountry);
        setDialCode(matchedCountry.dialCode || "");
        setMobileLength(matchedCountry.phoneLength || 10);
      }
    }
  };

  const handleAddOrEdit = () => {
    const nameRegex = /^[A-Za-z\s'-]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const trimmedFirst = firstName.trim();
    const trimmedLast = lastName.trim();
    const trimmedEmail = email.trim();
    const trimmedPhone = phone.trim();

    if (!selectedCountry) return toast.error("Please select a country");

    if (!trimmedFirst) return toast.error("First Name is required");
    if (!nameRegex.test(trimmedFirst)) return toast.error("Invalid First Name");

    if (!trimmedLast) return toast.error("Last Name is required");
    if (!nameRegex.test(trimmedLast)) return toast.error("Invalid Last Name");

    if (!trimmedEmail) return toast.error("Email is required");
    if (!emailRegex.test(trimmedEmail)) return toast.error("Invalid Email");

    if (!trimmedPhone) return toast.error("Phone is required");
    // if (!/^\d{10}$/.test(trimmedPhone))
    //   return toast.error("Phone must be 10 digits");
    // if (!/^[6-9]\d{9}$/.test(trimmedPhone))
    //   return toast.error("Enter valid Phone Number");

    if (trimmedPhone.length !== mobileLength) {
      toast.error(`Phone number must be exactly ${mobileLength} digits`);
      return;
    }

    if (!/^\d+$/.test(trimmedPhone)) {
      toast.error("Phone number must contain only digits");
      return;
    }

    const isEdit = !!selectedUser?._id;

    const emailExists = admins.some(
      (admin) =>
        (admin.email || "").toLowerCase() === trimmedEmail.toLowerCase() &&
        admin._id !== (selectedUser?._id || "")
    );
    const phoneExists = admins.some(
      (admin) =>
        admin.phone === trimmedPhone && admin._id !== (selectedUser?._id || "")
    );

    if (emailExists) return toast.error("Email already exists");
    if (phoneExists) return toast.error("Phone already exists");

    const payload = {
      name: `${trimmedFirst} ${trimmedLast}`,
      email: trimmedEmail,
      phone: trimmedPhone,
      role: role ? role.trim() : "Admin",
      userRole: selectedRoleId || selectedUser?.userRole?._id || null,
      countryCode: selectedCountry?._id || null,
      jeweller: finalJewellerId,
      allowAdminMobileAccess: isAllowAdminMobileAccessFeatureEnabled
        ? allowAdminMobileAccess
        : false,
    };

    setIsSaving(true); // start loader

    setTimeout(() => {
      if (isEdit) {
        dispatch(
          editAdminRequest({ userId: selectedUser._id, userData: payload })
        );
        toast.success("Admin updated successfully");
        // window.location.reload();
      } else {
        dispatch(createAdminRequest(payload));
        //toast.success("Admin created successfully");
        // window.location.reload();
      }

      setIsSaving(false); // stop loader
      setOpenDialog(false);
      setSelectedUser(null);
      setRefresh((prev) => !prev);
    }, 3000); // 300ms delay
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          width: "100%",
          mr: 2,
          height: "100%",
          mt: 0,
          mb: { xs: 2, md: 2 },
          background: "#fff",
          borderRadius: "3px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Box sx={{ justifyContent: "space-between", display: "flex", p: 2 }}>
          <Typography
            fontFamily={"Aeonik"}
            sx={{ fontSize: "24px", fontWeight: 700 }}
          >
            Admin List
          </Typography>
          {canCreateAdmin && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                textTransform: "none",
                background:
                  "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
                fontFamily: "inherit",
              }}
              onClick={handleOpenDialog}
            >
              New Admin
            </Button>
          )}
        </Box>

        <CardContent sx={{ width: "100%" }}>
          <AdminList
            refresh={refresh}
            onEdit={(row) => {
              setSelectedUser(row);
              populateEditForm(row);
              setOpenDialog(true);
            }}
          />
        </CardContent>
      </Box>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          sx: {
            borderRadius: "3px",
            // p: { xs: 1, sm: 2 },
          },
        }}
      >
        <Box sx={{ overflowY: "auto" }}>
          <Box
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              cursor: "pointer",
              background: "#E2E2EA",
              borderRadius: "50%",
              width: 26,
              height: 26,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#646464",
            }}
            onClick={handleCloseDialog}
          >
            <RxCross2 />
          </Box>
          <Typography
            fontWeight={700}
            fontSize={24}
            fontFamily={"Aeonik"}
            p={2}
            sx={{
              background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
              color: "#fff",
            }}
          >
            {selectedUser ? "Edit Admin" : "Create Admin"}
          </Typography>
          <Divider />
          <Box p={2}>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label={
                    <>
                      First Name <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  size="small"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  sx={{ width: "350px" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label={
                    <>
                      Last Name <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  fullWidth
                  size="small"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  sx={{ width: "350px" }}
                />
              </Grid>
              {Permission && (
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl size="small" sx={{ width: "350px" }}>
                    <InputLabel id="role-label">
                      Select Role <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      labelId="role-label"
                      value={role}
                      onChange={(e) => {
                        const selectedRole = createdRoles.find(
                          (r) => r.role === e.target.value
                        );
                        setRole(e.target.value);
                        setSelectedRoleId(selectedRole?._id);
                      }}
                      label="Select Role"
                    >
                      <MenuItem value="" disabled>
                        <em>Select Role</em>
                      </MenuItem>

                      {/* Merge logic: if role not in createdRoles, add it for this edit only */}
                      {[
                        ...filteredRoles.filter(
                          (r) => r.role.toLowerCase() !== "god"
                        ),
                        ...(selectedUser &&
                        role &&
                        !filteredRoles.some((r) => r.role === role)
                          ? [{ _id: "temp", role }]
                          : []),
                      ].map((r) => (
                        <MenuItem key={r._id} value={r.role}>
                          {r.role}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
            </Grid>

            <Grid container spacing={2} mt={2}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label={
                    <>
                      Email ID <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  type="email"
                  fullWidth
                  size="small"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{ width: "350px" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl size="small" sx={{ width: "350px" }}>
                  <InputLabel id="country-label">
                    Select Country Code <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="country-label"
                    value={selectedCountry?._id || ""}
                    label="Select Country"
                    onChange={(e) => {
                      const country = activeCountries.find(
                        (c) => c._id === e.target.value
                      );
                      setSelectedCountry(country);
                      setDialCode(country?.dialCode || "");
                      setMobileLength(country?.phoneLength || 10);
                    }}
                  >
                    {activeCountries.map((country) => (
                      <MenuItem key={country._id} value={country._id}>
                        {country.countryCode} ({country.dialCode})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box display="flex" alignItems="center">
                  <TextField
                    label={
                      <>
                        Primary Phone <span style={{ color: "red" }}>*</span>
                      </>
                    }
                    fullWidth
                    size="small"
                    value={phone}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*$/.test(val)) {
                        // only digits
                        if (val.length <= mobileLength) setPhone(val);
                        else
                          toast.error(`Phone must be ${mobileLength} digits`);
                      }
                    }}
                    sx={{ width: "300px" }}
                    InputProps={{
                      startAdornment: (
                        <Typography sx={{ mr: 1, fontWeight: 500 }}>
                          {dialCode || ""}
                        </Typography>
                      ),
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
            {isAllowAdminMobileAccessFeatureEnabled && (
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={allowAdminMobileAccess}
                        onChange={(e) =>
                          setAllowAdminMobileAccess(e.target.checked)
                        }
                      />
                    }
                    label="Allow Admin Mobile Access"
                  />
                </Grid>
              </Grid>
            )}

            <DialogActions sx={{ mt: 2 }}>
              <Button
                type="button"
                variant="contained"
                sx={{
                  background:
                    "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
                  px: 6,
                  textTransform: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={handleAddOrEdit}
                disabled={isSaving}
              >
                {isSaving ? (
                  <CircularProgress size={20} sx={{ color: "#fff" }} />
                ) : selectedUser ? (
                  "Update"
                ) : (
                  "Add"
                )}
              </Button>
            </DialogActions>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

export default CreateAdmin;
